<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="userForm" :model="userForm"  :label-width="75" label-position="right" @submit.native.prevent>
        <Row type="flex" :gutter="24">
          <Col v-bind="grid">
            <FormItem label="导读分类："  label-for="cate_id">
              <Select v-model="userForm.cate_id" class="perW90" @on-change="onChangeStatus">
                <Option :value="0">全部</Option>
                <Option v-for="item in cateList" :value="item.id" :key="item.id">
                  {{item.title}}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="导读名称："  label-for="key">
              <Input search enter-button placeholder="请输入" clearable v-model="userForm.key" @on-search="userSearchs">
              </Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex">
          <Col>
            <Button type="primary"  icon="md-add" @click="add">添加导读</Button>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns2" :data="userInfo" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch v-model="row.status" :value="row.status" :true-value="1" :false-value="2" @on-change="changeSwitch(row)">
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="image">
          <div class="tabBox_img">
            <img :src="row.audioarr ? row.audioarr+'?x-oss-process=video/snapshot,t_7000,f_jpg,w_800,h_600,m_fast' : require('@/assets/images/avatar.png')">
          </div>
        </template>
        <template slot-scope="{ row, index }" slot="is_hot">
          <span v-if="row.is_hot == 1">否</span>
          <span v-if="row.is_hot == 2">是</span>
        </template>
        <template slot-scope="{ row, index }" slot="is_recommend">
          <span v-if="row.is_recommend == 1">否</span>
          <span v-if="row.is_recommend == 2">是</span>
        </template>

        <template slot-scope="{ row, index }" slot="action">
          <a @click="edit(row)">编辑</a>
          <Divider type="vertical" />
          <template>
            <Dropdown @on-click="changeMenu(row,$event,index)">
              <a href="javascript:void(0)">
                更多
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
<!--                <DropdownItem name="pics">图片管理</DropdownItem>-->
                <DropdownItem name="del" divided>删除</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </template>
        </template>
      </Table>
      <Page :total="dataCount" :current="userForm.page" :page-size="userForm.limit" class="acea-row row-right page" show-total  @on-change="changepage"></Page>
    </Card>
    <!--删除-->
    <modalSure ref="modalSure" title="绘本" :id="id" :modelApi="modelApi" @closeModal="closeModal"></modalSure>
  </div>
</template>

<script>
import { booklist, delBook, changeStatus, getCate } from '@/api/bookVideo'
import modalSure from '@/components/modalSure'
export default {
  name: 'infoList',
  components: { modalSure },
  inject: ['reload'],
  data () {
    return {
      userForm: {
        page: 1,
        limit: 10,
        key: '',
        cate_id: 0
      },
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      modelApi: delBook,
      id: 0,
      dataCount: 0,
      userInfo: [],
      cateList: [],
      loading: false,
      userid: 0,
      columns2: [
        {
          title: 'ID',
          key: 'id',
          minWidth: 80
        },
        {
          title: '导读标题',
          key: 'title',
          minWidth: 120
        },
        {
          title: '绘本编号',
          key: 'book_sn',
          minWidth: 120
        },
        {
          title: '分类',
          key: 'cate',
          minWidth: 120
        },
        {
          title: '封面图',
          slot: 'image',
          minWidth: 120
        },
        {
          title: '播放次数',
          key: 'number_count',
          minWidth: 120
        },
        {
          title: '是否精选推荐',
          slot: 'is_hot',
          minWidth: 120
        },
        {
          title: '是否每日推荐',
          slot: 'is_recommend',
          minWidth: 120
        },
        {
          title: '状态',
          slot: 'status',
          minWidth: 120
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 180
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 120
        }
      ]
    }
  },
  created () {
    this.goodsList()
    this.getCate()
  },
  methods: {
    goodsList () {
      this.loading = true
      booklist(this.userForm).then(res => {
        let data = res.data
        this.userInfo = data.list
        this.dataCount = data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changepage (status) {
      this.userForm.page = status
      this.goodsList()
    },
    // 表格搜索
    userSearchs () {
      this.userForm.page = 1
      this.goodsList()
    },
    selectChange () {
      this.userForm.key = ''
    },
    edit (row) {
      this.$router.push({ path: '/admin/bookVideo/info/add/' + row.id })
    },
    add () {
      this.$router.push({
        path: '/admin/bookVideo/info/add'
      })
    },
    del (row) {
      this.id = row.id
      this.$refs.modalSure.isShow = true
    },
    // 上下架
    changeSwitch (row) {
      changeStatus(row.id).then(async res => {
        this.$Message.success(res.msg)
        this.goodsList()
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    closeModal (val) {
      this.goodsList()
    },
    onChangeStatus (val) {
      this.userForm.cate_id = val
      this.goodsList()
    },
    getCate () {
      getCate().then(res => {
        this.cateList = res.data
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    changeMenu (row, name) {
      switch (name) {
        case 'pics':
          this.$router.push({
            name: 'book-detail-list',
            params: { pid: row.id }
          })
          break
        default:
          this.del(row)
      }
    }
  }
}
</script>
